define('helperEntity-isTaskInScore',[],function() {

    var isTaskInScore = function(entity) {
        return (entity && entity.contentEntity && entity.contentEntity.inScore) ? true : false;
    };

    return isTaskInScore;
});

